<template>
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative">
        <vs-sidebar class="items-no-padding" parent="#chat-app" v-model="isChatSidebarActive" :click-not-close="clickNotClose" :hidden-background="clickNotClose">
            <VuePerfectScrollbar class="chat-scroll-area pt-4" :settings="settings" :key="$vs.rtl">
                <!-- CONTACTS LIST -->
                <div class="chat__contacts">
                    <h6 class="text-primary my-5 px-4">سفارشات دیگر کاربر</h6>
                    <ul class="chat__contacts" style="min-witdh: 400px!important;">
                        <li class="cursor-pointer" style="margin: 5px 0px;" v-for="(contact, index) in contactsList.items" :key="index" @click="updateContact(contact.id)">
                            <vx-card class="chat__contact flex items-center px-2" :class="{'bg-primary-gradient text-white shadow-lg': contact.isActiveChatUser}">
                                <div class="">
                                    <h5 class="" :class="{'text-white': contact.isActiveChatUser}">سفارش شماره ی {{ contact.order_number }}</h5>
                                </div>
                                <span>{{ contact.status }} 
                                    <!-- ({{ setTime(contact.created_at) }}) -->
                                </span>
                                <!-- <div class="mt-4">
                                    <span :class="{'text-white': contact.isActiveChatUser}">{{ contact.created_at }}</span>
                                </div> -->
                            </vx-card>
                        </li>
                    </ul>
                </div>
            </VuePerfectScrollbar>
        </vs-sidebar>

        <!-- RIGHT COLUMN -->
        <div class="chat__bg chat-content-area border d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': clickNotClose}">
            <template>
                <div class="chat__navbar">
                    <div class="chat__header">
                        <vs-navbar class="p-4 flex navbar-custom sticky" color="primary" type="flat">
                            <div class="relative flex mr-4">
                                <vs-avatar class="m-0 border-2 border-solid border-white" size="40px" :src="photoURL" />
                            </div>
                            <h3 class="color-w">{{ fullName }}</h3>
                            <vs-spacer></vs-spacer>
                            <feather-icon class="inline-flex cursor-pointer p-2 color-w" icon="ArrowLeftIcon" @click="$router.push({name: 'orders'}).catch(() => {})" />
                        </vs-navbar>
                    </div>
                </div>
                <!-- <div class="chat-content-scroll-area border border-solid d-theme-border-grey-light" style="padding-top:60px; max-height: 85vh; overflow: scroll;"> -->
                <VuePerfectScrollbar class="chat-content-scroll-area border border-solid d-theme-border-grey-light" :settings="settings" ref="chatLogPS" :key="$vs.rtl">

                    <div class="chat__log" ref="chatLog">
                        <chat-log :orderId="orderId"></chat-log>
                    </div>
                    </VuePerfectScrollbar>
                <!-- </div> -->
                <div class="chat__input flex p-4 bg-white" @keydown.enter="sendMsg()">
                    <vs-input class="flex-1" placeholder="پیام خود را بگذارید..." v-model="typedMessage" @keyup.enter="sendMsg()"/>

                    <div class="upload-btn-wrapper cursor-pointer">
                        <feather-icon icon="PaperclipIcon" class="attach-btn"/>
                        <input type="file" id="file" ref="file" @change="uploadFile()" />
                    </div>

                    <vs-button class="bg-primary-gradient mx-2" type="filled" @click="sendMsg()">ارسال</vs-button>
                    <vs-button class="bg-primary-gradient mx-2" type="filled" @click="AddFactorInfo()">صدور فاکتور</vs-button>
                </div>
            </template>
        </div>

        <AddFactor :popupAddFactor='popupAddFactor' :orderId='orderId' @updatePopupAddFactor='updatePopupAddFactor'/>

    </div>
</template>

<script>
import AddFactor from './../../dashboard/factors/Add'
import ChatLog from './ChatLog.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    data() {
        return {
            orderId: 0,
            userId: '',
            photoURL: require('./../../../assets/images/portrait/profile.jpg'),
            fullName: '',
            isChatSidebarActive: true,
            clickNotClose: true,
            file: '',
            typedMessage: '',

            popupAddFactor: false,

            settings: {
                maxScrollbarLength : 60,
                wheelSpeed         : 0.70,
            },
        }
    },

    components: {
        AddFactor,
        ChatLog,
        VuePerfectScrollbar,
    },

    watch: {
        windowWidth() {
            this.setSidebarWidth()
        },

        orderId(newVal, oldVal) {
            this.contactsList.items.forEach(contact => {
                if(contact.id == newVal){
                    contact.isActiveChatUser = true
                }
                if(contact.id == oldVal){
                    contact.isActiveChatUser = false
                }
            })
        }
    },

    computed: {
        contactsList() {
            return {
                items: this.$store.state.chat.contacts.map((robot) => {
                    let active = false
                    if(robot.id == this.orderId){
                        active = true
                    }
                    return {
                        id: robot.id,
                        order_number: robot.order_number,
                        isActiveChatUser: active,
                        created_at: robot.created_at,
                        status: robot.status
                    }
                })
            }
        },
    },

    created() {
        this.orderId = parseInt(localStorage.getItem('orderId'))
        this.userId = parseInt(localStorage.getItem('userId'))
        
        let data = {
            userId: this.userId,
            type: localStorage.getItem('type')
        }
        this.$store.dispatch('getSameOrders', data).catch(() => {
            this.$vs.notify({
                title: '',
                text: 'خطا در دریافت سفارشات مشابه',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })
        this.$store.dispatch("getUserInfo", this.userId).then((res) => {
            this.fullName = res.data.name + ' ' + res.data.last_name
        }).catch(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: '',
                text: 'خطا در دریافت اطلاعات کاربر',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning'
            })
        })

        this.contactsList.items.forEach(contact => {
            if(contact.id == this.orderId){
                contact.isActiveChatUser = true
            }
        })

        this.setSidebarWidth()
    },

    methods: {
        setTime(date) {
            const date_time = date.split(" ");
            return `${date_time[1]} ${date_time[0]}`
        },

        setSidebarWidth() {
            if (this.windowWidth < 1200) {
                this.isChatSidebarActive = this.clickNotClose = false
            } else {
                this.isChatSidebarActive = this.clickNotClose = true
            }
        },

        toggleChatSidebar(value = false) {
            if (!value && this.clickNotClose) return
            this.isChatSidebarActive = value
        },

        updateContact(id){
            localStorage.setItem('orderId', id)
            this.orderId = id
        },

        sendMsg() {
            if (!this.typedMessage) return
            const payload = {
                order_id: localStorage.getItem('orderId'),
                type: "message",
                value: this.typedMessage
            }
            this.$store.dispatch('sendMessage', payload).catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'خطا در اتصال به اینترنت',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                })
            })
            this.typedMessage = ''
        },

        uploadFile() {
            this.$vs.loading()
            this.file = this.$refs.file.files[0];
            let formData = new FormData();
            formData.append('value', this.file);
            formData.append('order_id', localStorage.getItem('orderId'));
            formData.append('type', 'file');
            this.$store.dispatch('uploadFile', formData)
            .then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
					title: '',
					text: 'فایل با موفقیت آپلود شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
            })
            .catch(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    title: '',
                    text: 'خطا در اتصال به اینترنت',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
				})
			})
        },


        AddFactorInfo(){
			this.popupAddFactor = true
		},

        updatePopupAddFactor(value){
            this.popupAddFactor = value
		},
    },
}

</script>

<style>
.vs-sidebar.vs-sidebar-parent{
    position: fixed !important;
}
</style>


<style scoped>
.sticky {
  position: fixed!important;
  top: 0!important;
  width: 80%!important;
}

.color-w {
    color: #f2f2f2;
}
.upload-btn-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
}

.attach-btn {
    color: #fb8103;
    background-color: white;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 20px;
    font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
}

.file-body {
    background-color: #f9c48d;
}

.sidebar-spacer--wide {
    width: calc(100% - 260px);
    margin-left: 260px;
}

.chat__input {
    position: fixed;
    bottom: 0;
    width: 80%;
    z-index: 1000;
    margin-top: 20px;
}


#chat-app {
    background-image: url(data:image/png;base64,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);
}
</style>
